module.exports = __webpack_public_path__ + "img/logo.baab0a0c.png";